import { faGear } from "@fortawesome/free-solid-svg-icons/faGear";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog, DialogContent, DialogTitle, Icon } from '@mui/material'
import { PaperArrastavel } from 'app/components/dialog-arrastavel/PaperArrastavel'
import clsx from 'clsx'
import React, { useState, useCallback } from 'react'

const estilosGridItens = require('./grid-estoque.module.scss').default
const estilosTableHead = require('../../itens-orcamento/grid-itens/head/tableHead.module.scss').default

import { IColuna } from 'app/types/IColuna'

export type AcoesHeadProps = {
    onAlterarFonte?: (tamanho: number) => void
    colunas: IColuna[]
    onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void
    onToggleSelecionarTodasColunas: (selecionar: boolean) => void
    tamanhoFonte: number
    exibirIconesAumentarDiminuirFonte?: boolean
    larguraLinha?: number
    nomeGrid?: "PESQUISAR_CLIENTE_ORCAMENTO"
    permiteEngrenagemGrid: boolean
}

export const AcoesHead = React.memo(({
    onAlterarFonte,
    colunas,
    onToggleColunaSelecionada,
    onToggleSelecionarTodasColunas,
    tamanhoFonte,
    exibirIconesAumentarDiminuirFonte = true,
    larguraLinha,
    permiteEngrenagemGrid
}: AcoesHeadProps) => {
    const [mostrarFerramentas, setMostrarFerramentas] = useState<boolean>(false)
    const [icon, setIcon] = useState<string>('arrow_drop_up')
    const [exibirSelecaoColunas, setExibirSelecaoDeColunas] = useState(false)

    const handleToggleFerramentas = useCallback(() => {
        setMostrarFerramentas(prev => !prev)
        setIcon(prev => prev === 'arrow_drop_up' ? 'arrow_drop_down' : 'arrow_drop_up')
    }, [])

    const selecaoDeColunas = (
        <div className="_grid _grid-cols-1 _grid-flow-row">
            <div className="_flex _flex-row _justify-start _max-w-xs _items-end">
                <div className="_mr-4">
                    <input
                        type="checkbox"
                        checked={colunas.every(c => c.Selecionada)}
                        onChange={e => onToggleSelecionarTodasColunas(e.target.checked)} 
                    />
                </div>
                <b>Todas</b>
            </div>
            {colunas.map(coluna => (
                <div className="_flex _flex-row _justify-start _max-w-xs _items-end" key={coluna.Nome}>
                    <div className="_mr-4">
                        <input
                            type="checkbox"
                            checked={coluna.Selecionada ?? false}
                            onChange={() => onToggleColunaSelecionada(coluna.Nome, !coluna.Selecionada)}
                        />
                    </div>
                    {coluna.Nome}
                </div>
            ))}
        </div>
    )

    const selecaoDeColunasDialog = (
        <Dialog open={exibirSelecaoColunas} onClose={() => setExibirSelecaoDeColunas(false)} PaperComponent={PaperArrastavel}>
            <DialogTitle>Selecionar colunas para exibição</DialogTitle>
            <DialogContent>{selecaoDeColunas}</DialogContent>
        </Dialog>
    )

    const botoes = (
        <div 
            style={{ width: larguraLinha ? `${larguraLinha}px` : undefined }} 
            className={clsx(["_flex _flex-row _mt-4 _gap-x-2", estilosTableHead.acoesHead])}
        >
            {permiteEngrenagemGrid && 
                <FontAwesomeIcon 
                    icon={faGear} 
                    className="_text-2xl _cursor-pointer" 
                    onClick={() => setExibirSelecaoDeColunas(true)} 
                />}
            {exibirIconesAumentarDiminuirFonte && (
                <>
                    <button
                        className={clsx('no-global-button', estilosGridItens.botaoAumentarDiminuirFonte)}
                        onClick={() => onAlterarFonte?.(tamanhoFonte + 1)}
                        disabled={tamanhoFonte >= 26}
                    >
                        A+
                    </button>
                    <button
                        className={clsx('no-global-button', estilosGridItens.botaoAumentarDiminuirFonte)}
                        onClick={() => onAlterarFonte?.(tamanhoFonte - 1)}
                        disabled={tamanhoFonte <= 8}
                    >
                        A-
                    </button>
                </>
            )}
        </div>
    )

    return (
        <>
            <div className={clsx("_mt-12", estilosTableHead.menu)}>
                <button
                    style={{ marginLeft: '14px', height: '20px' }}
                    id="table-headgrid-itensarrow"
                    className="no-global-button"
                    onClick={handleToggleFerramentas}
                >
                    <Icon>{icon}</Icon>
                </button>
                {mostrarFerramentas && <section>{botoes}</section>}
            </div>
            {exibirSelecaoColunas && selecaoDeColunasDialog}
        </>
    )
})
